function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 19v-1.5h7.225c1.167 0 2.17-.387 3.013-1.163.841-.774 1.262-1.737 1.262-2.887s-.42-2.112-1.262-2.887c-.842-.776-1.846-1.163-3.013-1.163H6.85l2.85 2.85-1.05 1.05L4 8.65 8.65 4 9.7 5.05 6.85 7.9h7.35c1.583 0 2.946.533 4.088 1.6C19.428 10.567 20 11.883 20 13.45c0 1.567-.57 2.883-1.712 3.95-1.142 1.067-2.505 1.6-4.088 1.6H7z",
  fill: "#474747"
})));